import script from "./MicelioView.vue?vue&type=script&setup=true&lang=js"
export * from "./MicelioView.vue?vue&type=script&setup=true&lang=js"

import "./MicelioView.vue?vue&type=style&index=0&id=8183cc06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8183cc06"]])

export default __exports__